














import { KEYCODE } from "@/constants/event";
import { enumToValues } from "@/helpers/type-helper";
import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props, EventTypes } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "TimelineEventBox",
  props: {
    eventType: {
      type: String as PropType<Props["eventType"]>,
      required: true,
      validator(value) {
        return enumToValues(EventTypes).includes(value);
      }
    },
    name: {
      type: String,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    labelClass() {
      return {
        "event__label--ownOrganization":
          this.eventType === EventTypes.OwnOrganization,
        "event__label--thisYear": this.eventType === EventTypes.ThisYearEvent,
        "event__label--oneYearAgo":
          this.eventType === EventTypes.OneYearAgoEvent,
        "event__label--twoYearAgo":
          this.eventType === EventTypes.TwoYearAgoEvent
      };
    },
    selectedClass() {
      return {
        "event__label--ownOrganization--isSelected":
          this.labelClass["event__label--ownOrganization"] && this.isSelected,
        "event__label--thisYear--isSelected":
          this.labelClass["event__label--thisYear"] && this.isSelected,
        "event__label--oneYearAgo--isSelected":
          this.labelClass["event__label--oneYearAgo"] && this.isSelected,
        "event__label--twoYearAgo--isSelected":
          this.labelClass["event__label--twoYearAgo"] && this.isSelected
      };
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
    handleKeydown(event) {
      if (event.keyCode !== KEYCODE.ENTER) {
        return;
      }
      this.$emit("click");
    }
  }
});
